import type { QuoteCancelRequest } from 'apiConnector/quote';
import { quoteApiConnector } from 'apiConnector/quote';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export function cancelQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('QUOTE_CANCELLED', 'STREAMING_CANCELLED'),
      filter(action => action.workspace === 'dynamic' || action.workspace === 'static'),
      mergeMap(({ negotiationId, quoteId, productSubtype, productType, ...action }) => {
        const request = {
          negotiationId,
          quoteId,
          productSubtype,
          screenMode: action.workspace === 'dynamic' ? 'NewDynamic' : 'NewStatic',
          productType,
        } satisfies QuoteCancelRequest;

        return quoteApiConnector(httpClient)
          .cancelQuote(request)
          .pipe(
            ignoreElements(),
            catchError(() => {
              return EMPTY;
            }),
          );
      }),
    );
}
